<script>
    export let tool;
</script>

<a class="tool-link" href={tool.url??''} target="_blank" rel="noopener noreferrer">
    {#if tool.color}
        <div class="tool-link-square"
             style="background-color:{tool.color}">
            <img src={tool.img??''} alt="icon"/>
        </div>
    {:else}
        <div class="tool-link-square">
            <img src={tool.img??''} alt="icon"/>
        </div>
    {/if}
    <div class="tool-name">
        {tool.title}
    </div>
</a>

<style>
    .tool-link {
        width: min-content;
        height: min-content;
        padding: .5em;
        transition-duration: 150ms;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        align-items: center;
        border-radius: 1em;
    }

    a {
        all: unset;
    }

    .tool-link:hover {
        transform: scale(1.1) translate(-2px, -2px);
    }

    .tool-link-square {
        height: 5em;
        width: 5em;
        border-radius: 1em;
        background-color: var(--theme-colors-background-appicon);
        display: grid;
        place-items: center;
        transition-duration: inherit;
        box-shadow: 0 0 10px 0 rgba(0,0,0,0.2);
    }

    .tool-link:active > .tool-link-square::after {
        position: absolute;
        z-index: -1;
        height: inherit;
        width: inherit;
        margin: auto;
        content: '';
        border: none;
        border-radius: 1em;
        animation-name: ripple;
        animation-duration: 300ms;
        animation-timing-function: ease-out;
    }

    @keyframes ripple {
        from {
            opacity: 1;
            border: solid rgba(0, 0, 0, .2) 3px;
            transform: scale3d(0.9, 0.9, 1);
        }

        to {
            opacity: 0;
            border: solid rgba(0, 0, 0, .2) 3px;
            transform: scale3d(1.8, 1.8, 1);
        }
    }


    .tool-link:hover > .tool-link-square {
        box-shadow: 2px 2px 10px 2px rgba(0, 0, 0, 0.2);
    }

    .tool-link:hover > .tool-name {
        text-shadow: 2px 2px 1px rgba(0, 0, 0, 0.1);
    }

    .tool-name {
        width: 7em;
        text-align: center;
        padding-top: 0.3em;
        padding-bottom: 0.3em;
        overflow: hidden;
        overflow-wrap: break-word;
    }

    img {
        width: 80%;
        height: 80%;
        object-fit: contain;
    }
</style>